"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var findIndex_1 = tslib_1.__importDefault(require("lodash/findIndex"));
var action_types_1 = require("./action-types");
exports.ROOT_KEY = 'paxProgress';
/*******************************************************************
 * Initial state
 *******************************************************************/
var initialState = {
    noSavedMsg: true,
    paxProgress: {
        programId: null,
        goalQuestMyPlanVOs: []
    },
    chart: {
        level: {},
        progress: { values: [] },
        goal: { lastDay: {} },
        goalProgress: { paxGoalSelection: {} },
        loaded: false
    },
    finalResult: {},
    busyFetchingPaxPlanDetails: false,
    busySavingPlanSets: false,
    views: {}
};
exports.DEFAULT_ORG_HIERARCHY = [{ id: 'Corporate', name: 'Corporate' }];
//TODO: Get these string values from CMMO
exports.DEFAULT_ACTION_STEP_TEXT = 'default action step text';
exports.POSITIVE_PLACEHOLDER = 'positive example';
exports.OBSTACLE_PLACEHOLDER = 'obstacle example';
function paxPlanDefault() {
    return {
        actionSteps: [
            {
                actionStep: '',
                actionStepStatus: false
            }
        ]
    };
}
exports.paxPlanDefault = paxPlanDefault;
/*******************************************************************
 * Reducers
 *******************************************************************/
function sliceViewOrgHierarchyReducer(state, action) {
    if (state === void 0) { state = initialState; }
    var _a;
    var orgViewHierarchy = get_1.default(state, "views[" + action.programViewId + "].orgViewHierarchy", exports.DEFAULT_ORG_HIERARCHY);
    var existingIndex = !action.orgUnitId ? 0 : findIndex_1.default(orgViewHierarchy, function (org) { return org.id === action.orgUnitId; });
    if (existingIndex === -1) {
        return state;
    }
    var newHierarchy = existingIndex === 0 ? exports.DEFAULT_ORG_HIERARCHY : orgViewHierarchy.slice(0, existingIndex + 1);
    return tslib_1.__assign({}, state, { views: tslib_1.__assign({}, state.views, (_a = {}, _a[action.programViewId] = tslib_1.__assign({}, get_1.default(state, "views[" + action.programViewId + "]", {}), { orgViewHierarchy: newHierarchy }), _a)) });
}
/**
 * paxProgress : Reducer
 * @param state
 * @param action
 * @returns {*}
 */
function progressReducer(state, action) {
    if (state === void 0) { state = initialState; }
    var _a, _b, _c, _d;
    switch (action.type) {
        case action_types_1.NO_SAVED_MSG:
            return tslib_1.__assign({}, state, { noSavedMsg: false });
        case action_types_1.UNLOAD_PROGRESS_DATA:
            return tslib_1.__assign({}, state, { paxProgress: initialState.paxProgress, chart: initialState.chart });
        case action_types_1.SET_PAX_PLAN_DETAILS:
            return tslib_1.__assign({}, state, { paxProgress: action.paxPlanData });
        case action_types_1.SET_PARTICIPANT_PROGRESS:
            var newState = tslib_1.__assign({}, state, { paxProgress: action.paxProgress.plan, finalResult: action.paxProgress.finalResult || {}, chart: tslib_1.__assign({}, action.paxProgress.chart, { loaded: true }) });
            if (!newState.paxProgress.goalQuestMyPlanVOs) {
                newState.paxProgress.goalQuestMyPlanVOs = [];
            }
            if (newState.paxProgress.goalQuestMyPlanVOs.length === 0) {
                newState.paxProgress.goalQuestMyPlanVOs = [paxPlanDefault()];
            }
            return newState;
        case action_types_1.ADD_PLAN:
            return tslib_1.__assign({}, state, { paxProgress: {
                    programId: state.paxProgress.programId,
                    goalQuestMyPlanVOs: tslib_1.__spread(state.paxProgress.goalQuestMyPlanVOs, [paxPlanDefault()])
                } });
        case action_types_1.ACTION_STEP_UPDATED:
            var myPlans = state.paxProgress.goalQuestMyPlanVOs.map(function (plan) {
                return tslib_1.__assign({}, plan, { actionSteps: plan.actionSteps.map(function (step) {
                        return tslib_1.__assign({}, step);
                    }) });
            });
            myPlans[action.planIndex].actionSteps[action.index] = tslib_1.__assign({ id: action.id }, myPlans[action.planIndex].actionSteps[action.index], { actionStep: action.value, actionStepStatus: action.completed });
            return tslib_1.__assign({}, state, { paxProgress: {
                    programId: state.paxProgress.programId,
                    goalQuestMyPlanVOs: myPlans
                } });
        case action_types_1.PLAN_UPDATED:
            var plans = state.paxProgress.goalQuestMyPlanVOs.map(function (plan) {
                return tslib_1.__assign({}, plan, { actionSteps: plan.actionSteps.map(function (step) {
                        return tslib_1.__assign({}, step);
                    }) });
            });
            if (action.updateObstacleAndPostive) {
                var plan = plans[action.planIndex];
                plan.positive = action.positive;
                plan.obstacle = action.obstacle;
            }
            return tslib_1.__assign({}, state, { noSavedMsg: true, paxProgress: {
                    programId: state.paxProgress.programId,
                    goalQuestMyPlanVOs: plans
                } });
        case action_types_1.SET_VIEW_PROGRESS_DATA:
            var parentOrgUnitName = get_1.default(action.progressData, 'hierarchyTable.parentOrgUnitName') || 'Corporate';
            exports.DEFAULT_ORG_HIERARCHY[0].id = parentOrgUnitName;
            exports.DEFAULT_ORG_HIERARCHY[0].name = parentOrgUnitName;
            return tslib_1.__assign({}, state, { views: tslib_1.__assign({}, state.views, (_a = {}, _a[action.programViewId] = tslib_1.__assign({ orgViewHierarchy: exports.DEFAULT_ORG_HIERARCHY }, get_1.default(state, "views[" + action.programViewId + "]", {}), { progress: action.progressData, lastUpdated: Date.now() }), _a)) });
        case action_types_1.SET_VIEW_ORG_TABLE_DATA:
            return tslib_1.__assign({}, state, { views: tslib_1.__assign({}, state.views, (_b = {}, _b[action.programViewId] = tslib_1.__assign({}, get_1.default(state, "views[" + action.programViewId + "]", {}), { orgTables: tslib_1.__assign({}, get_1.default(state, "views[" + action.programViewId + "].orgTables", {}), (_c = {}, _c[action.orgUnitId] = action.tableData, _c)) }), _b)) });
        case action_types_1.ADD_VIEW_ORG_HIERARCHY:
            return tslib_1.__assign({}, state, { views: tslib_1.__assign({}, state.views, (_d = {}, _d[action.programViewId] = tslib_1.__assign({}, get_1.default(state, "views[" + action.programViewId + "]", {}), { orgViewHierarchy: tslib_1.__spread(get_1.default(state, "views[" + action.programViewId + "].orgViewHierarchy", exports.DEFAULT_ORG_HIERARCHY), [
                        tslib_1.__assign({}, action.orgUnit)
                    ]) }), _d)) });
        case action_types_1.SLICE_VIEW_ORG_HIERARCHY:
            return sliceViewOrgHierarchyReducer(state, action);
        default:
            return state;
    }
}
exports.progressReducer = progressReducer;
//# sourceMappingURL=reducers.js.map